import React, { useLayoutEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { Button } from '../../../../global/button/Button'
import { Text, TextH3 } from '../../../Typography/Typography'
import { FullPageModalMobile } from '../FullPageModalMobile'
import { ModalTitle } from '../common/components/ModalTitle'
import { cloneButtonMobile, getSortedButtons } from '../common/helpers/button'
import { MessageModalProps } from './MessageModal'

import styles from './MessageModalMobile.module.scss'

const useLargeContent = (props: MessageModalProps) => {
  const { isLoading } = props

  const containerRef = useRef<HTMLDivElement>(null)
  const [containerHeight, setContainerHeight] = useState(0)

  useLayoutEffect(() => {
    const currentContainerRef = containerRef.current
    currentContainerRef && setContainerHeight(currentContainerRef.offsetHeight)
  }, [isLoading])

  const isLargeContent = containerHeight > window.innerHeight * 0.8

  return { isLargeContent, containerRef }
}

export const MessageModalMobile: React.FC<MessageModalProps> = (props) => {
  const { isLoading = false, children, icon, onClose } = props

  const { t } = useTranslation()
  const { isLargeContent, containerRef } = useLargeContent(props)

  return (
    <FullPageModalMobile
      renderFooter={({ onClose }) =>
        getSortedButtons(props, [
          cloneButtonMobile(
            <Button appearance='primary' onClick={onClose}>
              {t('Close')}
            </Button>
          ),
        ])
      }
      isLoading={isLoading}
      onClose={onClose}
    >
      <div ref={containerRef}>
        {icon && (
          <div
            className={classNames(styles.icon, {
              [styles.sm]: isLargeContent,
            })}
          >
            {icon}
          </div>
        )}
        <div>
          <Header {...props} />
          <div>{children}</div>
        </div>
      </div>
    </FullPageModalMobile>
  )
}

const Header: React.FC<MessageModalProps> = (props) => {
  const { title, description } = props

  return (
    <div className={styles.header}>
      {title && (
        <TextH3 align='center'>
          <div className={styles.title}>
            <span>
              <ModalTitle title={title} />
            </span>
          </div>
        </TextH3>
      )}
      {description && (
        <div className={styles.description}>
          <Text isParagraph align='center'>
            {description}
          </Text>
        </div>
      )}
    </div>
  )
}
